<div class="row nav-row">
  <div class="nav-container">
    <div class="row nav-row">
      <div class="nav-col nav-col-3">
        <ul [ngClass]="isSupportRoute ? 'activeTop' : ''" class="nav nav-tabs nav-fill justify-content-end nav-left-padding">
          <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
            <div *ngIf="isLoggedIn" dropdown class="truncate">
              <!--<a routerLink="MyProfile/Overview">
                <span id="button-basic" class="nav-address-btn btn btn-primary nav-btn truncate">
                  <b title="{{accountStreetAddress}}">{{accountStreetAddress}}</b>
                  <br />
                  <small title="{{accountNumber}}">{{accountNumber}}</small>
                </span>
              </a>
              <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu  dropdown-menu-left nav-address-drop-down"
                  role="menu" aria-labelledby="button-basic">
                <li *ngFor="let acct of acctDetails" role="menuitem"><a class="dropdown-item active" href="#"><b>{{ acct?.address2 }}</b><br />{{ acct?.accountNumber }}</a></li>
                <li class="divider dropdown-divider"></li>
              </ul>-->

              <select [(ngModel)]="selectedID" name="acctDetails" id="acctSelect" (ngModelChange)="switchAccount($event)">
                <option *ngFor="let acct of acctDetails" [value]="acct.accountId">
                  {{ acct?.address1 }} | {{ acct?.accountNumber }}
                </option>
              </select>
            </div>
            <div></div>
          </li>

          <!-- BILLING ROUTES -->
          <!--<li *ngIf="isBillingRoute" class="nav-item bp-nav-link" [routerLinkActive]="['active']">
    <a class="nav-link bp-text" routerLink="Billing/PaymentArrangements">Payment Arrangements</a>
  </li>-->

          <li *ngIf="isLoggedIn" class="nav-item bp-nav-link" [routerLinkActive]="['active']">
            <a class="nav-link bp-text" routerLink="MyProfile/LoginInfo">Login Information</a>
          </li>
          <li *ngIf="isLoggedIn" class="nav-item bp-nav-link" [routerLinkActive]="['active']">
            <a class="nav-link bp-text" routerLink="MyProfile/ContactInfo">Contact Information</a>
          </li>
          <li *ngIf="isLoggedIn" class="nav-item bp-nav-link" [routerLinkActive]="['active']">
            <a class="nav-link bp-text" routerLink="MyProfile/Alerts">Alerts & Communications</a>
          </li>

        </ul>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/nav/nav.component.html